import { type ReactElement, useState } from 'react';

interface ImageWithFallbackProps {
  readonly src: string | null;
  readonly alt: string;
  readonly className?: string;
  readonly loading?: 'lazy' | 'eager';
  readonly failureText?: string;
  readonly onError?: () => void;
  readonly draggable?: boolean;
}

/** URL별 key를 사용하여 새 서명 URL의 로딩 실패 상태를 분리한다. */
export const ImageWithFallback = ({
  src,
  alt,
  className,
  loading = 'lazy',
  failureText = '사진 없음',
  onError,
  draggable,
}: ImageWithFallbackProps): ReactElement => {
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  if (src === null || failedUrl === src) {
    return (
      <span className="flex size-full items-center justify-center p-4 text-center text-sm text-muted-foreground">
        {failureText}
      </span>
    );
  }
  return (
    <img
      src={src}
      alt={alt}
      loading={loading}
      draggable={draggable}
      className={className}
      onError={() => {
        setFailedUrl(src);
        onError?.();
      }}
    />
  );
};
